import { isProduction } from '@this/src/util';

export const isDebugPanelEnabled = (): boolean => {
  if (typeof process !== 'undefined' && process.env?.REACT_APP_DEBUG_PANEL_ENABLED === 'false') {
    return false;
  }
  if (isProduction()) {
    return false;
  }
  return true;
};
